import React, { useState } from "react";
import Button from "../../components/Button";
import DatePicker from "../../components/DatePicker";
import SearchInput from "../../components/SearchInput";

const FilterBar = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  search,
  setSearch,
  handleSearch,
}) => {
  const [openPicker, setOpenPicker] = useState(null);

  const handleFromDateChange = (newFromDate) => {
    if (!toDate) return setFromDate(newFromDate);
    const to = new Date(toDate.split("-").reverse().join("-"));
    const from = new Date(newFromDate.split("-").reverse().join("-"));
    if (from > to) {
      alert("⚠️ Ngày bắt đầu không được lớn hơn ngày kết thúc.");
      return;
    }
    setFromDate(newFromDate);
  };

  const handleToDateChange = (newToDate) => {
    if (!fromDate) return setToDate(newToDate);
    const from = new Date(fromDate.split("-").reverse().join("-"));
    const to = new Date(newToDate.split("-").reverse().join("-"));
    if (to < from) {
      alert("⚠️ Ngày kết thúc không được nhỏ hơn ngày bắt đầu.");
      return;
    }
    setToDate(newToDate);
  };

  const handleDatePickerToggle = (picker) => {
    setOpenPicker((prev) => (prev === picker ? null : picker));
  };

  return (
    <div className="flex flex-wrap items-center gap-3 motion-safe:animate-[fadeIn_240ms_ease-out]">
      {/* LEFT GROUP */}
      <div className="flex flex-wrap items-center gap-3">
        {/* Search Input */}
        <SearchInput
          value={search}
          placeholder="Tìm kiếm hồ sơ"
          onChange={(event) => setSearch(event.target.value)}
          onSearch={handleSearch}
          className="md:w-[400px]"
        />

        {/* Date Pickers Group */}
        <div className="flex items-center gap-3">
          {/* From Date Picker */}
          <div className="w-full min-w-[290px] max-w-[290px]">
            <DatePicker
              placeholder="Từ ngày"
              height="42px"
              initValue={fromDate}
              onChange={handleFromDateChange}
              isCalendarOpen={openPicker === "fromDate"}
              onToggle={() => handleDatePickerToggle("fromDate")}
            />
          </div>

          {/* To Date Picker */}
          <div className="w-full min-w-[290px] max-w-[290px]">
            <DatePicker
              placeholder="Đến ngày"
              height="42px"
              initValue={toDate}
              onChange={handleToDateChange}
              isCalendarOpen={openPicker === "toDate"}
              onToggle={() => handleDatePickerToggle("toDate")}
            />
          </div>
        </div>
      </div>

      {/* RIGHT GROUP - Apply Button */}
      <Button
        type="button"
        variant="primary"
        size="lg"
        onClick={handleSearch}
        aria-label="Áp dụng bộ lọc"
      >
        Áp dụng
      </Button>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default FilterBar;
